module.exports = __webpack_public_path__ + "static/media/wy.370269c0.svg";